import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import Button from '../../../shared/button';

const SavedReportModal = ({ show, closeModal, saveReportName }) => {
  const [reportName, setReportName] = useState('');

  const savingDisabled = !reportName.trim();

  const submitForm = (event) => {
    event.preventDefault();
    if (savingDisabled) return;

    saveReportName(reportName);
    setReportName('');
    closeModal();
  };

  return (
    <Modal show={show} onHide={closeModal}>
      <form onSubmit={submitForm}>
        <Modal.Header closeButton>
          <Modal.Title>Save As</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <label>Report Name</label>
          <input
            className="form-control"
            name="report-name"
            placeholder="Enter report name"
            type="text"
            value={reportName}
            onChange={e => setReportName(e.target.value)}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button.Cancel name="close-report" type="button" onClick={closeModal}>Close</Button.Cancel>
          <Button.Primary disabled={savingDisabled} name="save-report" type="submit">
            Save
          </Button.Primary>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

SavedReportModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  saveReportName: PropTypes.func.isRequired,
  selectedFilterValues: PropTypes.object.isRequired,
  show: PropTypes.bool.isRequired
};

export default SavedReportModal;